export default __webpack_public_path__ + "static/media/icon_paper_DL.e12f38b8.svg";